import React from 'react';
import VendorAppointments from '../components/vendorAppointments/VendorAppointments';

const VendorAppointmentPage = () => {
    return <VendorAppointments />;
};

export default VendorAppointmentPage;
